<template>
  <div id="watch" class="page">
    <VideoPlayer :options="videoOptions" />
    <ContentHeader header-title="Programmering" />
    <Schedule />
  </div>
</template>


<script>
import VideoPlayer from "@/components/VideoPlayer.vue";
import ContentHeader from "@/components/ContentHeader.vue";
import Schedule from "@/components/Schedule.vue"

export default {
  name: "Watch",
  components: {
    VideoPlayer,
    ContentHeader,
    Schedule,
  },
  data() {
    return {
      videoOptions: {
        autoplay: true,
        controls: true,
        sources: [
          {
            src: "https://live.streamteam.eu:8443/parkstad/parkstad/live/live/playlist.m3u8",
            type: "application/x-mpegURL",
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss">
// #player-wrapper {
//   position: relative;
//   overflow: hidden;
//   width: 100%;
//   padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
//   margin-bottom: 16px;
// }
</style>